<div class="container">
  <span class="sectionTitle">Dx10 Search</span>

  <div class="col-12 alert alert-danger" *ngIf="searchError">
    {{ searchErrorMessage }}
  </div>

  <div class="input-group mb-4">
    <input type="search" class="form-control shadow-sm"  placeholder="Search by Desc or Dx..." aria-label="Search DXs..." name="searchDXs" [(ngModel)]="searchQuery" (keyup.enter)="search(searchQuery)" />
    <div class="input-group-append">
      <button class="btn btn-secondary shadow-sm" type="button" (click)="search(searchQuery)" >
        <fa-icon [icon]="faSearch"></fa-icon>
      </button>
    </div>
  </div>

  <div class="col-12 mb-1" *ngIf="searchCount == 100">
    <span class="boldCount">There are 100+ results for your search. Only the first 100 are showing.</span>
    <span class="legend100">
        <strong>{{ dxYear }} DXs:&nbsp;
            <span class="newGreen"> New=Green</span>
            <span class="delRed"> Deleted=Red</span>
            <span class="revisedPurple"> Revised=Purple</span>
        </strong>
      </span>
  </div>

  <!-- search tips go hear if results more than 50 -->
  <div class="col-12 alert alert-warning" *ngIf="searchCount == 100">
    <p>Search Tips: to narrow your results, you can use more than one search term.</p>
    <p>Search terms do not need to be full words.</p>
    <p>Example: 'diab hyperg' will find 'diabetes' AND/OR 'hyperglycemia'.</p>
  </div>

  <div class="col-12 mb-1" *ngIf="searchCount > 0 && searchCount !== 100">
    <span class="boldCount">There are {{ searchCount }} results for your search.</span>
    <span class="legend">
      <strong>{{ dxYear }} DXs:&nbsp;
          <span class="newGreen"> New=Green</span>
          <span class="delRed"> Deleted=Red</span>
          <span class="revisedPurple"> Revised=Purple</span>
      </strong>
    </span>
  </div>

  <!-- Search results table goes here -->
  <div class="table-responsive" *ngIf="foundset">
      <table class="table table-striped table-bordered">
        <thead class="table-dark">
          <tr>
            <th>Dx10</th>
            <th>Desc</th>
            <th>Dx9</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dx of foundset; let i = index">
            <td [ngClass]="{'delRed': dx.fieldData.Status == 'Deleted', 'newGreen': dx.fieldData.Status == 'New', 'revisedPurple': dx.fieldData.Status == 'Updated'}">{{ dx.fieldData.ICD10 }}</td>
            <td [ngClass]="{'delRed': dx.fieldData.Status == 'Deleted', 'newGreen': dx.fieldData.Status == 'New', 'revisedPurple': dx.fieldData.Status == 'Updated'}">{{ dx.fieldData.ICD10desc }}</td>
            <td width="10%">
                <div *ngFor="let dx9 of foundset[i].portalData.ICD9">{{ dx9['ICD9::ICD9'] }}</div>
            </td>
          </tr>
        </tbody>
      </table>
  </div>

</div>
